import { v4 as uuidv4 } from "uuid";
export class AppsUpdateModel {
    constructor() {
        this.appsId = uuidv4();
    }
}
export default class addProducts extends AppsUpdateModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
